import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { withRights } from 'providers/RightsConsumer';
import { Autocomplete, Button } from '@totalsoft/rocket-ui';

class OfferPartnerEligibilityForm extends React.PureComponent {
  state = {
    saving: false,
    shouldValidate: false
  };

  handleSave = async () => {
    this.setState({ saving: true, shouldValidate: true });
    await this.props.onSave();
    this.setState({ saving: false });
  };

  handleEligibilityChange =
    (type, isProxy, valueField = 'value') =>
    value => {
      let newValue = isProxy ? value.target[valueField] : value;

      this.props.onChange(type, newValue);
    };

  handleChange = (value, id) => {
    this.setState({ shouldValidate: false });
    this.props.onChange(value, id);
  };

  isValid = value => {
    return typeof value !== 'undefined' && value !== null && value !== '';
  };
  trim = str => str.replace(/^\s+|\s+$/g, '');
 
  render() {
    const { t, data, isValid, rights, isDirty } = this.props;
    const { saving, shouldValidate } = this.state;

    return (
      <>
        <Grid container spacing={3}>
          {data &&
            data.map((field, idx) => (
              <Grid item xs={12} md={6} key={field.eligibilityId}>
                <Autocomplete
                  id={'offerPartnerEligibilityCard_' + idx + '_name'}
                  fullWidth
                  value={field.selectedValue || ''}
                  onChange={e => this.handleChange(e, field.eligibilityId)}
                  error={shouldValidate ? !field.selectedValue : false}
                  label={field.name}
                  valueKey='id'
                  simpleValue
                  name={field.name}
                  options={field.options}
                  disabled={rights.readOnlyFull || !rights.clientEligibilityWrite}              
                />
              </Grid>
            ))}
          {!rights.isImage && (
            <Grid item xs={12}>
              <Button
                id={'offerPartnerEligibilityCard_saveBtn'}
                onClick={this.handleSave}
                disabled={rights.readOnlyFull || saving || !isValid || !isDirty || !rights.clientEligibilityWrite}
              >
                {saving ? t('Saving') : t('Save')}
              </Button>
            </Grid>
          )}
        </Grid>
      </>
    );
  }
}

OfferPartnerEligibilityForm.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
  isValid: PropTypes.bool.isRequired,
  isDirty: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};

export default compose(withTranslation())(withRights(OfferPartnerEligibilityForm));
